module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch2",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "VST"
  }, [_c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "id": "ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("We Have Work to Do")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "VSB"
  }, [_vm._v("She is kind, in a no-nonsense way.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("It feels strange speaking to a medical")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("professional about the personal and broken")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("parts "), _c('i', [_vm._v("inside")]), _vm._v(" me. I’m on the other end of the")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("desk. "), _c('i', [_vm._v("I’m used to talking one on one with my")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("patients.")]), _vm._v(" Yet here I am … sick. "), _c('i', [_vm._v("I want you to")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("write down the first thing that comes to your")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("mind and we’ll take it from there.")]), _vm._v(" She wants")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("me to use my love of words as therapy. She")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("hands me a canary yellow notebook, a tool to")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("help me release my emotions. She doesn’t know")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("I’ve already been doing this for over 30 years.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("She tells me to bring it with me each visit.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("The following day, when she reads my first")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("entry, she sighs. “W"), _c('i', [_vm._v("e have work to do.")]), _vm._v("”")])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('b', [_c('i', [_vm._v("I tried so hard, but I could never")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('b', [_c('i', [_vm._v("make this world love me.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 72
// module chunks = 0